import { ConfirmModal } from '@/components/modal/ConfirmModal'

type DisplayText = 'healthInsurer' | 'destination'
type Props = {
  onConfirm: () => void
  onCancel: () => void
  displayText: DisplayText
}
function getDisplayName(displayText: DisplayText): string {
  switch (displayText) {
    case 'healthInsurer':
      return '保険者'
    case 'destination':
      return '送達先'
    default:
      return ''
  }
}
export const ShowHistoryConfirmModal = ({ onConfirm, onCancel, displayText }: Props) => {
  return (
    <ConfirmModal
      title="確認"
      titleColor="blue"
      message={
        <>
          適用開始日が本日以前のため、編集できません。
          <br />
          かわりに新しい{getDisplayName(displayText)}情報として登録されますがよろしいですか？
        </>
      }
      confirmLabel="はい"
      cancelLabel="キャンセル"
      onConfirm={onConfirm}
      onCancel={onCancel}
    />
  )
}
